import api from '@/utils/api'

export const fetchAdminVideo = (params) => {
  return api.get(`/videos/`, {params: params})
    .then(resp => {
      return (resp.data)
    })
}
export const fetchTrainerVideo = (trainer, params) => {
  return api.get(`/trainers/${trainer.id}/videos/`, {params: params})
    .then(resp => {
      return (resp.data)
    })
}
export const fetchRunnerVideo = (runner, params) => {
  return api.get(`/runners/${runner.id}/videos/`, {params: params})
    .then(resp => {
      return (resp.data)
    })
}

export const createAdminVideo = (obj) => {
  return api.post(`/videos/`, obj)
    .then(resp => {
      return (resp.data)
    })
}
export const updateAdminVideo = (obj) => {
  return api.put(`/videos/${obj.id}/`, obj)
    .then(resp => {
      return (resp.data)
    })
}
export const createTrainerVideo = (trainer, obj) => {
  return api.post(`/trainers/${trainer.id}/videos/`, obj)
    .then(resp => {
      return (resp.data)
    })
}
export const updateTrainerVideo = (trainer, obj) => {
  return api.put(`/trainers/${trainer.id}/videos/${obj.id}/`, obj)
    .then(resp => {
      return (resp.data)
    })
}

export const deleteAdminVideo = (obj) => {
  return api.delete(`/videos/${obj.id}/`, obj)
    .then(resp => {
      return (resp.data)
    })
}
export const deleteTrainerVideo = (trainer, obj) => {
  return api.delete(`/trainers/${trainer.id}/videos/${obj.id}/`, obj)
    .then(resp => {
      return (resp.data)
    })
}



// WEBPACK FOOTER //
// ./src/videos/api.js